<!-- Created by Arga Ghulam Ahmad - arga@jojonomic.com -->
<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      :class="cover ? '' : 'no-cover'"
      class="notification-screen loading-screen">
      <div class="notification-screen-box">
        <div class="floating-container">
          <jLottie
            :options="defaultOptions"
            :height="400"
            :width="420"
            class="animation"
            @animCreated="handleAnimation"/>
          <h1
            class="title">
            Please Wait
          </h1>
          <h2
            id="loading-screen-message"
            class="message">
            {{ message }}
          </h2>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable no-underscore-dangle,vue/require-default-prop */
import jLottie from '../lottie/jLottie';
import * as animationData from '../../assets/notification/loading.json';

export default {
  name: 'JLoadingScreen',
  components: {
    jLottie,
  },
  props: {
    message: String,
  },
  data() {
    return {
      defaultOptions: {
        animationData,
      },
      animationSpeed: 1,
      isVisible: false,
      cover: true,
    };
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
    showLoadingScreen() {
      this.isVisible = true;
    },
    showCoverLoadingScreen() {
      this.cover = true;
      this.isVisible = true;
    },
    showTransparentLoadingScreen() {
      this.cover = false;
      this.isVisible = true;
    },
    hideLoadingScreen() {
      this.isVisible = false;
      this.cover = true;
    },
    closeLoadingScreen() {
      this.isVisible = false;
      this.cover = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/notification-screen/jLoadingScreen.vue